import React from "react";
import "@styles/components/movieInfo.scss";

const MovieBackground = ({ backdrop }) => {
  return (
    <div
      className="background-image"
      style={{ backgroundImage: `url(${backdrop})` }}
    />
  );
};

export default MovieBackground;
